async function requestToApi(payload) {
  const form = new FormData();
  let url, options, type;
  for (const param in payload.params) {
    form.append(param, payload.params[param]);
  }
  type = payload.type ? payload.type: "get";
  if (type == "post") {
    url = payload.url;
    options = {
      credentials: "include",
      method: "post",
      body: form,
    };
  } else if (type == "get") {
    url = payload.url + "?" + new URLSearchParams(form);
    options = {
      method: "get"
    };
  } else {
    return "no request type";
  }
  const response = await fetch(url, options);
  const data = await response.json();
  return data;
}
export default requestToApi;